import React, { useState, useEffect } from 'react';

const ScrollToTop = () => {
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsActive(window.scrollY > 100);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <a
            href="#"
            id="scroll-to-top"
            className={`back-to-top d-flex align-items-center justify-content-center${isActive ? ' active' : ''}`}
            onClick={(e) => {
                e.preventDefault();
                scrollToTop();
            }}
            aria-label="Scroll to top"
        >
            <i className="bi bi-arrow-up-short"></i>
        </a>
    );
};

export default ScrollToTop;
